import React from 'react'
import { useTranslation } from "react-i18next";
import location from "./../../../../Images/cablocationicon.png";
import msg from "./../../../../Images/cabmailicon.png";
import web from "./../../../../Images/cabwebicon.png";
import phn from "./../../../../Images/cabphnicon.png";
import Insta from "./../../../../Images/CabInsta.png";
import Facebook from "./../../../../Images/CabFacebook.png";
import Twitter from "./../../../../Images/CabTwitter.png";
import Youtube from "./../../../../Images/Cabyoutube.png";
import Gmail from "./../../../../Images/CabGmail.png";
import LinkedIn from "./../../../../Images/CabLinkedIn.png";
import Pinterest from "./../../../../Images/CabPinterest.png";
import Telegram from "./../../../../Images/CabTelegram.png";
import Whatsapp from "./../../../../Images/CabWhatsapp.png";
import CabAlternateUrl from './CabAlternateUrl';

const   LogisticContactInfo = ({ contdata, socialdata, alternateUrlData, colorData }) => {
  const { t } = useTranslation();
  let cnt = contdata
  const getSocialImage = (socialName) => {

    if (socialName == "FaceBook") {

      return (<div className='px-3 pb-4'>
        <img loading="lazy" className='w-fiftypx' src={Facebook} />
      </div>);
    } else if (socialName == "Twitter") {

      return (<div className='px-3 pb-4'>
        <img loading="lazy" className='w-fiftypx' src={Twitter} />
      </div>);
    } else if (socialName == "Youtube") {

      return (<div className='px-3 pb-4'>
        <img loading="lazy" className='w-fiftypx' src={Youtube} />
      </div>);
    } else if (socialName == "Gmail") {

      return (<div className='px-3 pb-4'>
        <img loading="lazy" className='w-fiftypx' src={Gmail} />
      </div>);
    } else if (socialName == "Instagram") {

      return (<div className='px-3 pb-4'>
        <img loading="lazy" className='w-fiftypx' src={Insta} />
      </div>);
    } else if (socialName == "whatsapp") {
      return (<div className='px-3 pb-4'>
        <img loading="lazy" className='w-fiftypx' src={Whatsapp} />
      </div>);
    } else if (socialName == "linkedin") {
      return (<div className='px-3 pb-4'>
        <img loading="lazy" className='w-fiftypx' src={LinkedIn} />
      </div>);
    } else if (socialName == "telegram") {
      return (<div className='px-3 pb-4'>
        <img loading="lazy" className='w-fiftypx' src={Telegram} />
      </div>);
    } else if (socialName == "pinterest") {
      return (<div className='px-3 pb-4'>
        <img loading="lazy" className='w-fiftypx' src={Pinterest} />
      </div>);
    }
  }

  let props = null

  let socialMediaData = socialdata;

  const getSocialIcon = (social) => {
    if (social == "gmail") {
      return "google";
    } else if (social == "facebook") {
      return "facebook-f";
    } else if (social == "twitter") {
      return "twitter";
    } else {
      return social;
    }
  };
  const getLink = (social, link) => {
    if (social == "whatsapp") {
      return `https://wa.me/${link}`;
    } else if (social == "envelope") {
      return `mailto:${link}`;
    } else if (social == "telegram") {
      return `https://t.me/${link}`;
    } else if (social == "pinterest") {
      return `https://in.pinterest.com/${link}`;

    } else {
      if (!link.startsWith("http://") && !link.startsWith("https://")) {
        link = "https://" + link;
      }
      link = link.replace("www.", "");
      return link;
    }
  };



  return (
    <div className='sec'>
      <div className='ContactDiv'>
        <h3 className='sectitle' style={{ color: colorData?.dynamicTextHeadingColor || "#02131B" }}>
          {colorData?.contactHeading || colorData?.rs?.headingsObj?.contactinfo_Heading || t("Contact_info")}
        </h3>

        {cnt?.contactInfoPhone &&
          <div className='contactItem' >
            <div className='iconMain' style={{ color: colorData?.dynamicTextHeadingColor ? `${colorData.dynamicTextHeadingColor}E5` : "#02131B" }}><i  style={{ color: colorData?.dynamicCtaColor || '#FF6600'}} class="fa-solid fa-phone"></i> <p style={{color: 'inherit'}}>{t('Call_us')}</p></div>
            <div className='itemText'>
              <a
                href={
                  cnt?.contactInfoPhone ? `tel:${cnt?.contactInfoPhone}` : ""
                }
              >
                <span
                  style={{
                    color: colorData?.dynamicTextHeadingColor
                      ? `${colorData.dynamicTextHeadingColor}B3`
                      : "#707070",
                  }}
                >
                  {cnt?.contactInfoPhone || ``}
                </span>
              </a>
            </div>
            {cnt?.optionalContactInfoPhone?.split("-")?.[1]?.length > 0 &&
              <div className='itemText'>
                {/* {cnt?.optionalContactInfoPhone} */}
                <a
                  href={
                    cnt?.optionalContactInfoPhone ? `tel:${cnt?.optionalContactInfoPhone}` : ""
                  }
                >
                  <span
                    style={{
                      color: colorData?.dynamicTextHeadingColor
                        ? `${colorData.dynamicTextHeadingColor}B3`
                        : "#707070",
                    }}
                  >
                    {cnt?.optionalContactInfoPhone || ``}
                  </span>
                </a>
              </div>}
          </div>
        }

        {cnt?.contactInfoWebUrl &&
          <div className='contactItem' >
            <div className='iconMain' style={{ color: colorData?.dynamicTextHeadingColor ? `${colorData.dynamicTextHeadingColor}E5` : "#02131B" }}><i style={{ color: colorData?.dynamicCtaColor || '#FF6600'}} class="fa-solid fa-globe"></i><p style={{color: 'inherit'}}>{t('Website')}</p></div>
            <div className='itemText'>
              {/* {cnt?.contactInfoWebUrl} */}
              <a
                href={(cnt?.contactInfoWebUrl) ? `http://${cnt?.contactInfoWebUrl.replace(/^(https?:\/\/)?(www\.)?/, '')}` : '#'}
                onClick={(e) => {
                  if (!cnt?.contactInfoWebUrl) {
                    e.preventDefault();
                  }
                }}
                target={cnt?.contactInfoWebUrl ? '_blank' : undefined}

              >  <span
                style={{
                  color: colorData?.dynamicTextHeadingColor
                    ? `${colorData.dynamicTextHeadingColor}B3`
                    : "#707070",
                }}
              >
                  {cnt?.contactInfoWebUrl}
                </span>
              </a>
            </div>
          </div>
        }
        {cnt?.contactInfoEmail &&
          <div className='contactItem' >
            <div className='iconMain' style={{ color: colorData?.dynamicTextHeadingColor ? `${colorData.dynamicTextHeadingColor}E5` : "#02131B" }}><i style={{ color: colorData?.dynamicCtaColor || '#FF6600'}} class="fa-solid fa-envelope"></i><p style={{color: 'inherit'}}>{t('EmailId')}</p></div>
            <div className='itemText'>
              {/* {cnt?.contactInfoEmail}  */}
              <a
                href={
                  cnt?.contactInfoEmail ? `mailto:${cnt?.contactInfoEmail}` : ""
                }
              >
                <span
                  style={{
                    color: colorData?.dynamicTextHeadingColor
                      ? `${colorData.dynamicTextHeadingColor}B3`
                      : "#707070",
                  }}
                >
                  {cnt?.contactInfoEmail}
                </span>
              </a>
            </div>
          </div>
        }

        {cnt?.contactInfoAddress &&
          <div className='contactItem' >
            <div className='iconMain' style={{ color: colorData?.dynamicTextHeadingColor ? `${colorData.dynamicTextHeadingColor}E5` : "#02131B" }}><i style={{ color: colorData?.dynamicCtaColor || '#FF6600'}} class="fa-solid fa-location-dot"></i><p style={{color: 'inherit'}}>{t('Location')}</p></div>
            <div className='itemText '
              style={{
                color: colorData?.dynamicTextHeadingColor
                  ? `${colorData.dynamicTextHeadingColor}B3`
                  : "#707070",
              }}
            >
              {cnt?.contactInfoAddress}</div>
          </div>
        }
        {cnt?.contactInfoOptAddress &&
          <div className='contactItem' >
            <p
              style={{
                color: colorData?.dynamicTextHeadingColor
                  ? colorData.dynamicTextHeadingColor
                  : "#707070", fontSize: "12px"
              }}>{t("Alternative_address")}</p>
            <div className='itemText ' style={{
              color: colorData?.dynamicTextHeadingColor
                ? `${colorData.dynamicTextHeadingColor}B3`
                : "#707070"
            }}>
              {cnt?.contactInfoOptAddress}</div>
          </div>
        }
      </div>

      {(colorData?.[colorData.businessObj ? 'businessObj' : 'rs']?.SocialMediaObj?.is_enabled == 1) &&
        <div style={{marginTop:'30px'}}>
          <h3 className='sectitle' style={{ color: colorData?.dynamicTextHeadingColor || "#02131B" }}>
            {colorData?.socialHeading || colorData?.rs?.headingsObj?.social_Heading || t("Social_media")}
          </h3>
          <div className='flex '>
            <ul className="socil-link w-hundred">
              {!!socialMediaData && socialMediaData.length > 0 && socialMediaData.map((val, index) => {
                const socialIcon = getSocialIcon(val?.nameOfSocial?.toLowerCase());
                const link = getLink(val?.nameOfSocial?.toLowerCase(), val?.link);

                if (val?.nameOfSocial && val?.link) {
                  return (
                    <>

                      <li key={index} >
                        <a href={link} target="_blank" style={{ color: colorData?.dynamicCtaColor || "#FF6600" }}>
                          <i className={`fa-${val?.nameOfSocial.toLowerCase() === 'envelope' ? 'solid' : 'brands'} fa-${socialIcon}`} style={{ color: colorData?.dynamicCtaColor || "#FF6600" }}>
                          </i>
                        </a>
                      </li>

                    </>
                  );
                }

                return null;
              })}
            </ul>
          </div>
        </div>
      }



      {(alternateUrlData?.is_enabled == 1) && (<div style={{marginTop:'30px'}}>
        <h3 className='sectitle' style={{ color: colorData?.dynamicTextHeadingColor || "#02131B " }}>
          {colorData?.alternateUrlsHeading || colorData?.rs?.headingsObj?.alternateUrls_Heading || t("Useful_links")}
        </h3>
        <div >
          <CabAlternateUrl altdata={alternateUrlData?.content} colorData={colorData}/>
        </div>
      </div>)}



    </div>
  )
}

export default LogisticContactInfo
